/* JSLIB - Intly.JS */
const lib = {
    'breakpoints': {
        'xs': 0,
        'sm': 640,
        'md': 768,
        'lg': 1024,
        'xl': 1280,
        'xxl': 1536
    },
    qsa: (name, loc = document) => {
      if (loc == "group") {
        return [
          ...document
            .querySelector(name)
            .closest("[data-group]")
            .querySelectorAll(name),
        ];
      }
  
      return [...loc.querySelectorAll(name)];
    },
    qs: (name, loc = document) => {
      if (loc == "group") {
        return [...document.closest("[data-group]").querySelectorAll(name)];
      }
  
      return loc.querySelector(name);
    },
    bod: () => {
      return lib.qs("body");
    },
    id: (name) => {
      return document.getElementById(name);
    },
    path: (name) => {
      if (name) {
        return window.location.pathname == name ? true : false;
      }
  
      return window.location.pathname;
    },
    themePath: (name) => {
      return lib.siteurl() + "/wp-content/themes/" + name;
    },
    siteurl: (name) => {
      if (name) {
        return window.location.origin == name ? true : false;
      }
  
      return window.location.origin;
    },
    elem: (elem, html) => {
      var wrapper = document.createElement(elem);
      wrapper.innerHTML = html;
      return wrapper.firstChild;
    },
    append: (name) => {},
    sleep: (m) => new Promise((r) => setTimeout(r, m)),
    stylesheet: {
      add: (url, id) => {
        let link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = url;
        link.id = id;
        document.getElementsByTagName("head")[0].appendChild(link);
      },
      remove: (id) => {
        if (!lib.id(id)) {
          return;
        }
        lib.id(id).remove();
      },
    },
    script: {
      add: (url, id) => {
        var script = document.createElement("script");
        script.src = url;
        script.id = id;
        document.body.append(script);
      },
      remove: (id) => {
        if (!lib.id(id)) {
          return;
        }
        lib.id(id).remove();
      },
    },
    inViewport: (elem, callback, options = {}) => {
      return new IntersectionObserver((entries) => {
        entries.forEach((entry) => callback(entry));
      }, options).observe(document.querySelector(elem));
    },
    inViewportClassic: (el) => {
      const rect = el.getBoundingClientRect();
      return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= window.innerHeight &&
        rect.left <= window.innerWidth
      );
    },
    isNearViewport: (el) => {
      const rect = el.getBoundingClientRect();
  
      return (
        rect.top >= -(window.innerHeight * 2) &&
        rect.bottom <= window.innerHeight * 2
      );
    },
    getParentNode: (element, level = 1) => {
      while (level-- > 0) {
        element = element.parentNode;
        if (!element) return null;
      }
      return element;
    },
  };
  
  export { lib as default };